module.exports = __webpack_public_path__ + "img/coreevent-logo.1b20288d.svg";